import Enum from "../../../enums/Enum";

const EnumCancellationReason = new Enum({
    EMERGENCY: "Emergency",
    CLINICIAN_REQUEST: "Clinician Request",
    MANAGEMENT_REQUEST: "Management Request",
    IN_TIME: "Cancellation in Advance",
    LATE: "Late Cancellation",
    CHARGED_LATE: "Charged Late Cancellation",
    STAFF_RESCHEDULED: "Rescheduled",
    RESCHEDULED: "Late Rescheduling"
});

// Set by the chatbot only; shown in tables but not selectable when staff cancel.
export const SYSTEM_CANCELLATION_REASONS = ["RESCHEDULED"];

export default EnumCancellationReason;